import React from 'react'
import { BorderColorControl } from '../controls/border-color-control'
import { BorderStyleControl } from '../controls/border-style-control'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { BorderWidthControl } from '../controls/border-width-control'
import { BorderRadiusControl } from '../controls/border-radius-control'
import { BorderTypeControl } from '../controls/border-type-control'
import { BorderType } from 'common/types/styleTypes'

export interface BorderGroupProps {
  border: Partial<BorderType> | undefined
  update: (value: Partial<BorderType>) => void
  isMobile?: boolean
  hideColorControl?: boolean
}

export const BorderGroup = ({
  border,
  update,
  isMobile,
  hideColorControl,
}: BorderGroupProps) => {
  return (
    <>
      <GroupTitle isMobile={isMobile}>
        settings_styles.border_style.group_title
      </GroupTitle>
      <BorderTypeControl label="" border={border} update={update} />
      <BorderStyleControl border={border} update={update} />
      <BorderWidthControl border={border} update={update} />

      <BorderRadiusControl border={border} update={update} />
      {!hideColorControl && (
        <BorderColorControl border={border} update={update} />
      )}
    </>
  )
}
